/**
 * @module Cart 
 *  Apis must need auth details to trigger url - NormalApi
 */

import store from '@/store/store';
import Env from '@/env';
import NormalApi from '@/Components/Controllers/NormalApis';
import VboutApis from '@/Components/Controllers/VboutApis';
import Helpers from '@/Components/Helpers/Helpers';

export default {
  /**
   * Create cart
   */
    async createCart(store_id, cartUrl) {
      const url = `${ Env.cartUrl }/api/v1/cart/create`;
      let obj = {
        location_id: store_id,
        app_version: Env.appVersion,
        platform: Env.appPlatform,
      };
      if(store.getters.getLoggedInUserId){
        obj.user_id = store.getters.getLoggedInUserId;
      }
      return NormalApi.postApi(url, '', obj).then(res => {
          store.dispatch('cart/setId', res.data.payload.id);
          // If we create cart and logged in push to vbout
          if(store.getters.getLoggedInUserToken){
            VboutApis.createCart(res.data.payload.id, store_id, cartUrl)
          }
          store.dispatch('cart/setCartDetail', res.data.payload);
          return res; 
        })
        .catch(err => err);
    },

    /**
     * fetch cart item
     */
    async fetch(store_id = null, cartUrl) {
     
      let cartId = store.getters['cart/id'];
      let cartDetail = store.getters['cart/cartDetail'];
        // if we have cart then cart id must match with location id because cart depends on lcoation id
      if(cartId == '' ||  cartId == undefined || cartDetail.location_id != store_id){
        // if cart id is not preset OR location has been change, get new cart id for changed location
        let cartCreate = await this.createCart(store_id, cartUrl);
        if(cartCreate.status == 200)
          cartId = cartCreate.data.payload.id;
        }
        const url = `${ Env.cartUrl }/api/v1/cart/${ cartId }/detail`;
        return NormalApi.getApi(url)
        .then(res => {
            store.dispatch('cart/setCartDetail', res.data.payload);
            if(store.getters.getLoggedInUserToken){
              VboutApis.createCart(res.data.payload.id, store_id, cartUrl)
            }
            if (res.data.payload.status == 'processing') {
              store.dispatch('cart/setCartItems', res.data.payload.cart_items);
            } else {
              store.dispatch('cart/setCartItems', []);
            }
            return res.data.payload;
        })
        .catch(err => {
            store.dispatch('cart/setCartDetail', {});
            store.dispatch('cart/setCartItems', []);
            return err;
        });
    },

    /**
     * 
     * Sync guest cart to user cart
     */
    async convertGuestCartToUserCart(cartUrl) {
      const url = `${ Env.cartUrl }/api/v1/cart/convertGuestCartToUserCart`;
      let obj = {
        cart_id: store.getters['cart/id'],
        user_id: store.getters.getLoggedInUserId,
        location_id: store.getters['location/selected'].id,
        app_version: Env.appVersion,
        platform: Env.appPlatform,
      };
      return NormalApi.postApi(url, '', obj).then(async (res) => {
          await VboutApis.createCart(res.data.payload.id, store.getters['location/selected'].id, cartUrl)
          store.dispatch('cart/setId', res.data.payload.id);
          store.dispatch('cart/setCartDetail', res.data.payload);
          return res; 
        })
        .catch(err => err);
    },


    /**
     * Add cart items
     */
    async add(obj, context) {
        // Send user activy emit, user , location details verified within the function
        Helpers.emitUserActivity();

        const url = `${Env.cartUrl}/api/v1/cartItem/create`;
        store.dispatch('spinner/setSpinner', true);
        return NormalApi.postApi(url, '', obj)
            .then(res => {
                // store.dispatch('spinner/setSpinner', false);
                store.dispatch('cart/setCartItems', res.data.payload.cart_items);
                return res;
            })
            .catch(err => {
                if(err.response && (err.response.status && err.response.status == 500) ) {
                  this.fetch(store.getters['location/selected'].id, Helpers.getLocationCartFullUrl(context));
                }
                // store.dispatch('spinner/setSpinner', false);
                return err;
            });
    },
    /**
     *  Update cart items
     */
    update(obj) {
        // Send user activy emit, user , location details verified within the function
        Helpers.emitUserActivity();

        let removeKeys = ['id', 'cart_id', 'line_total', 'note', 'updated_at', 'created_at', 'createdAt', 'updatedAt', 'deletedAt'];
        removeKeys.forEach(key => {
            delete obj[key];
        })
        store.dispatch('spinner/setSpinner', true);
        const url = `${Env.cartUrl}/api/v1/cartItem/update`;
        return NormalApi.postApi(url, {}, obj)
            .then(res => {
                store.dispatch('cart/setCartDetail', res.data.payload);
                store.dispatch('cart/setCartItems', res.data.payload.cart_items);
                // setTimeout(()=> {
                //   store.dispatch('spinner/setSpinner', false); // in case not working
                // }, 5000)
                return res;
            })
            .catch(err => {
                store.dispatch('spinner/setSpinner', false);
                return err;
            });
    },

    /**
     *  delete cart items
     */
    delete({ cart_product_id, location_id }) {
        store.dispatch('spinner/setSpinner', true);
        const url = `${Env.cartUrl}/api/v1/cartItem/${cart_product_id}/delete`;
        return NormalApi.deleteApi(url, '', {
                user_id: store.getters.getLoggedInUserId,
                location_id,
                app_version: "1.0",
                platform: "web"
            })
            .then(res => {
                store.dispatch('cart/setCartDetail', res.data.payload);
                store.dispatch('spinner/setSpinner', false);
                store.dispatch('cart/setCartItems', res.data.payload.cart_items);
                return res;
            })
            .catch(err => {
                store.dispatch('spinner/setSpinner', false);
                return err;
            });
    },

    // Get user Location cart
    async locationCart(store_id, cartUrl) {

      // we need store id
      if(!store_id){
        return false;
      }

      if(!store.getters.getLoggedInUserId ){
        // if we have cart id fetch , else create cart id cart/create{location_id:"dsakfhksaf"}
        return await this.fetch(store_id, cartUrl);
      }

      const url = `${ Env.cartUrl }/api/v1/cart/${ store.getters.getLoggedInUserId }/userCart?location_id=${store_id }`;
      return NormalApi.getApi(url)
        .then( async(res) => {
            await store.dispatch('cart/setCartDetail', res.data.payload);
             // Once we got cart ask for loyalty
            await VboutApis.createCart(res.data.payload.id, store_id, cartUrl)
            store.dispatch('cart/setId', res.data.payload.id);
            store.dispatch('cart/setCartItems', res.data.payload.cart_items);
            //store.dispatch('cart/setLoyalityPointsObj', 'geee');
            return res;
        })
        .catch(err => {
            store.dispatch('cart/setCartDetail', {});
            store.dispatch('cart/setId', '');
            store.dispatch('cart/setCartItems', []);
            return err;
        });
    },

    async clearcart(cart_id) {
      store.dispatch('spinner/setSpinner', true);
      const url = `${Env.cartUrl}/api/v1/cart/${cart_id}/clearCart`;
      return NormalApi.deleteApi(url, '', {})
        .then(async (res) => {
          let promocode = store.getters['cart/promocode'];
          if(promocode && promocode.code){
            // Remove promovode is available
            await this.promoCodeRemove(promocode.id);
          }
          store.dispatch('cart/setCartDetail', {});
          store.dispatch('spinner/setSpinner', false);
          store.dispatch('cart/setCartItems', []);
          return res;
        })
        .catch(err => {
            store.dispatch('spinner/setSpinner', false);
            return err;
        });
    },

    /**
     * Elavon token
     */
    generateElavonSessionToken(locationId) {
      const url = `${Env.cartUrl}/api/v1/cart/${locationId}/elavon_token`;
      return NormalApi.getApi(url)
        .then(res => res)
        .catch(err => err);
    },

    /**
     * Promocode apply
     */
     promoCodeApply({ cart_id, promocode , business_id , user_type}) {
      const url = `${Env.cartUrl}/api/v1/cartPromocode`;
      return NormalApi.postApi(url, {},{ 
        cart_id, 
        promocode, 
        business_id,
        user_type,
      })
        .then(res => res)
        .catch(err => err);
    },


    /**
     * Promocode remove
     */
     promoCodeRemove(promoCode) {
      const url = `${Env.cartUrl}/api/v1/cartPromocode/${promoCode}`;
      return NormalApi.deleteApi(url)
        .then(res => res)
        .catch(err => err);
    },

    /**
     * Get cart loyality points
     */
     getCartLoyalityPointOverview(cart_id, method = 'pickup') {
      // For this business must be enabled
      const url = `${Env.cartUrl}/api/v1/cartLoyalty/${cart_id}/preview?order_receive_method=${method}`;
        return NormalApi.getApi(url)
          .then(res => res)
          .catch(err => err);

    },

    /**
     * Redeem point on cart
     */
     redeemPointOnCart({ cart_id, points_to_redeem, order_received_method }) {
      const url = `${Env.cartUrl}/api/v1/cartLoyalty`;
      return NormalApi.postApi(url, {}, {
        cart_id,
        points_to_redeem,
        order_received_method,
      })
        .then(res => res)
        .catch(err => err);
    },

    /**
     * remove Redeem point on cart
     */
    removeRedeemPointOnCart(cart_loyality_id) {
      const url = `${Env.cartUrl}/api/v1/cartLoyalty/${cart_loyality_id}`;
      return NormalApi.deleteApi(url)
        .then(res => res)
        .catch(err => err);
    },

    /**
     * Validate with Greenline
     */
    prevalidateWithGreenline(cart_id, data) {
      if(!cart_id){
        return;
      }
      const url = `${Env.cartUrl}/api/v1/cart/${cart_id}/prevalidateWithGreenline`;
      return NormalApi.postApi(url,{}, data)
        .then(res => res)
        .catch(err => err);
    },


    /**
     * Validate with Tendy
     */
    prevalidateWithTendy(cart_id, data) {
      if(!cart_id){
        return;
      }
      const url = `${Env.cartUrl}/api/v1/cart/${cart_id}/prevalidateWithTendy`;
      return NormalApi.postApi(url,{}, data)
        .then(res => res)
        .catch(err => err);
    },
}